/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Shipping_AddressInputs */

const vi_customer_shipping_address = /** @type {(inputs: Customer_Shipping_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ giao hàng`)
};

/**

* @param {Customer_Shipping_AddressInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_shipping_address = /** @type {((inputs?: Customer_Shipping_AddressInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Shipping_AddressInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_shipping_address(inputs)
});